import { VideoPlayer } from "../../../../modules/content/components/VideoPlayer/VideoPlayer";
import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { IVideoBlockProps } from "./VideoBlock.props";

export const VideoBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  videoBanner,
  videoSource,
  vimeoVideo,
  youtubeVideo,
}: IVideoBlockProps) => {
  const selectedVideo = videoSource === "youtube" ? youtubeVideo : vimeoVideo;
  if (!selectedVideo) return null;
  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="sprout-chapter-tab sprout-paper-lift rounded-[1.5rem_1.5rem_1.5rem_0.35rem] border-[0.65rem] border-whiteboard pt-2">
          <VideoPlayer
            banner={videoBanner}
            source={videoSource}
            vimeoVideo={vimeoVideo}
            youtubeVideo={youtubeVideo}
          />
        </div>
      </div>
    </SproutSection>
  );
};

VideoBlock.displayName = "Block::VideoBlock";
